<template>
  <div class="container-fluid">
    <v-toolbar dense
               src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
    >
      <v-spacer></v-spacer>
      <v-btn
        class="ma-2"
        outlined
        color="error"
        v-if="toolbarButtonsVisible"
        @click="exportExcel"
      >
        Excel Export
      </v-btn>
      <v-btn
        class="ma-2"
        outlined
        color="error"
        v-if="toolbarButtonsVisible"
        @click="exportPdf"
      >
        PDF Export
      </v-btn>
    </v-toolbar>
    <v-data-table
      ref="collectionsTable"
      :headers="headers"
      :items="personalCollections"
      sort-by="orderId"
      class="elevation-1"
      :search="search"
      :items-per-page="-1"
      locale="cs"
      single-expand
      item-key="id"
      show-expand
      :single-select="singleSelect"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Osobní odběr</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Dnešní den</v-spacer>
          <v-menu
            v-model="dateFilterPicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <!-- ten filtr -->
              <v-text-field
                v-model="dateFilter"
                label="Filtr Data"
                hide-details
                single-line
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateFilter"
              @input="dateFilterPicker = false"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
          <v-select
            :items="timeTypes"
            label="Filtr denní"
            v-model="selectedTime"
            single-line
            item-text="name"
            return-object
            small-chips
            deletable-chips
            hide-details
          ></v-select>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Vyhledávání"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-container>
            <v-row>
              <v-col>
                <v-data-table
                  :headers="itemsHeaders"
                  :items="item.items"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      color="success"
                      outlined
                      @click="finish(item)"
                      v-if="!item.delivered && currentUser.roleId === 5"
                    >
                      Dokončit
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ExcelJS from 'exceljs'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
export default {
  Name: 'PesonalCollection',
  data: () => ({
    loading: true,
    toolbarButtonsVisible: false,
    singleSelect: false,
    dateFilter: new Date().toISOString().slice(0, 10),
    dateFilterPicker: false,
    selectedTime: null,
    selected: [],
    search: '',
    itemsHeaders: [
      { text: 'Název', value: 'name' },
      { text: 'Množství', value: 'quantity' },
      { text: 'Celková cena', value: 'price' },
      { text: 'Typ platby', value: 'paymentType' },
      { text: 'Zaplaceno', value: 'paid' },
      { text: '', value: 'actions' }
    ],
    headers: [
      { text: 'Název instituce / Jméno', value: 'name' },
      { text: 'Ulice', value: 'street' },
      { text: 'čp', value: 'streetNumber' },
      { text: 'Město', value: 'city' },
      { text: 'PSČ', value: 'zip' },
      { text: 'Denní doba', value: 'time' }
    ],
    timeTypes: [],
    personalCollectionsAll: []
  }),
  created () {
    this.initialize()
  },
  computed: {
    collectionsOrdered () {
      return this.$refs.collectionsTable.selectableItems
    },
    personalCollections () {
      if (!this.selectedTime) {
        return this.personalCollectionsAll
      }

      return this.personalCollectionsAll.filter(col => {
        return col.timeType === this.selectedTime.id
      })
    },
    ...mapGetters({ currentUser: 'user/currentUser' })
  },
  methods: {
    initialize () {
      this.getTimeTypes()
      this.getPersonalCollections()
    },
    getTimeTypes () {
      this.$http.get('/admin/times')
        .then(response => {
          this.timeTypes = this.keysToCamelCase(response.data)
        })
        .catch(err => console.log(err))
    },
    mapPersonalCollection (inputArr) {
      let offset = 0
      const result = []
      inputArr.forEach((subject, index) => {
        subject.name = subject.name || `${subject.firstName} ${subject.lastName}`
        const dayItems = [[], [], [], [], [], []]

        Object.keys(subject.paymentTypes).forEach(paymentType => {
          const meals = subject.paymentTypes[paymentType]

          meals.forEach(meal => {
            let mealPayment
            switch (+paymentType) {
              case 1: mealPayment = 'Kredit'; break
              case 3: mealPayment = 'Při převzetí'; break
              case 4: mealPayment = 'Bankovní převod'; break
              case 5: mealPayment = 'Kartou online'; break
            }

            meal.paid = meal.paid ? 'Ano' : 'Ne'
            dayItems[meal.timeId - 1].push({ ...meal, paymentType: mealPayment })
          })
        })

        dayItems.forEach((time, index) => {
          const timeName = this.timeTypes.find(tt => tt.id === index + 1).name
          if (time.length) {
            result.push({
              name: subject.name,
              street: subject.street,
              streetNumber: subject.streetNumber,
              city: subject.city,
              zip: subject.zip,
              timeType: index + 1,
              time: timeName,
              items: dayItems[index],
              index: offset++
            })
          }
        })
      })

      return result
    },
    getPersonalCollections () {
      this.loading = true
      this.toolbarButtonsVisible = false
      this.$http.post('/admin/delivery/personal-collection', {
        date: this.dateFilter
      })
        .then(response => {
          this.toolbarButtonsVisible = true
          this.personalCollectionsAll = this.mapPersonalCollection(this.keysToCamelCase(response.data))
          this.loading = false
        })
        .catch(err => { console.log(err) })
    },
    finish (item) {
      this.$http.post('/admin/order-confirm', {
        order_day_item_ids: item.orderDayItemIds
      })
        .then(() => {
          this.getPersonalCollections()
        })
    },
    exportExcel () {
      const workbook = new ExcelJS.Workbook()
      const sheet = workbook.addWorksheet('Osobní odběr')
      sheet.mergeCells('A1:C1')
      sheet.getCell('A1').value = 'Export osobního odběru'

      const now = new Date()
      const nowCzDate = now.toLocaleDateString('cs-CZ', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
      const nowCzTime = now.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
      sheet.mergeCells('A2:C2')
      sheet.getCell('A2').value = `${nowCzDate} ${nowCzTime}`

      sheet.getRow(4).values = this.headers.map(h => h.text)

      sheet.columns = [
        { key: 'street', width: 20 },
        { key: 'streetNumber', width: 40 },
        { key: 'city', width: 20 },
        { key: 'zip', width: 10 },
        { key: 'name', width: 30 },
        { key: 'time', width: 20 }
      ]
      let rowOffset = 5
      this.personalCollections.forEach((collection, index) => {
        sheet.getRow(rowOffset++).values = {
          ...collection
        }
        sheet.getRow(rowOffset++).values = [
          '',
          'Název',
          'Množství',
          'Cena',
          'Typ platby',
          'Zaplaceno'
        ]
        collection.items.forEach(item => {
          sheet.getRow(rowOffset++).values = [
            '',
            item.name,
            item.quantity,
            item.price,
            item.paymentType,
            item.paid
          ]
        })
      })
      sheet.eachRow(row => {
        row.eachCell(cell => {
          cell.alignment = { vertical: 'middle', horizontal: 'right' }
        })
      })
      workbook.xlsx.writeBuffer().then(function (data) {
        const blob = new Blob([data],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = 'export_osobni_odber.xlsx'
        anchor.click()
        window.URL.revokeObjectURL(url)
      })
    },
    exportPdf () {
      const now = new Date()
      const nowCzDate = now.toLocaleDateString('cs-CZ', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
      const nowCzTime = now.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })

      const tableCollections = []
      this.personalCollections.forEach(col => {
        tableCollections.push([
          col.street,
          col.streetNumber,
          col.city,
          col.zip,
          col.name,
          col.time
        ])

        tableCollections.push([
          '',
          'Název',
          'Množství',
          'Cena',
          'Typ platby',
          'Zaplaceno'
        ])
        col.items.forEach(item => {
          tableCollections.push([
            '',
            item.name,
            item.quantity,
            item.price,
            item.paymentType,
            item.paid
          ])
        })
      })
      pdfMake.vfs = pdfFonts.pdfMake.vfs
      const docDefinition = {
        content: [
          {
            text: 'Osobní odběr'
          },
          {
            text: `${nowCzDate} ${nowCzTime}`
          },
          {
            table: {
              body: [
                this.headers.map(h => h.text),
                ...tableCollections
              ]
            }
          }
        ]
      }
      pdfMake.createPdf(docDefinition).download('export_osobni_odber')
    }
  },
  watch: {
    dateFilter () {
      this.getPersonalCollections()
    }
  }
}
</script>

<style scoped>

</style>
